export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/permute.js
// module id = XFTn
// module chunks = 0